<template>
  <list-obligations
    @save="onSave"
    @delete="onDeleteAdhoc"
    :obligations="obligations"
    :name="employee.fullName"
    :type="resx.labels.employee_obligation"
    :heading="heading"
    :details="details"
  >
    <template v-if="isSystemUser && employee._id" #notes>
      <v-row class="mx-0">
        <v-col cols="12" md="6" class="pa-0">
          <notes-panel
            fill
            scope="employeeObligations"
            :contractor-id="contractor._id"
            :value="employee.notes"
            :size="contractor.notesSize && contractor.notesSize.employeeObligations"
            :save-value="v => saveText('notes', v)"
            @saved="v => onTextSaved('notes', v)"
          >
          </notes-panel>
        </v-col>
        <v-col cols="12" md="6" class="pa-0">
          <notes-panel
            fill
            scope="employeeObligations"
            :label="resx.labels.comments_visible_to_company"
            :resizable="false"
            :value="employee.comments"
            :save-value="v => saveText('comments', v)"
            @saved="v => onTextSaved('comments', v)"
          >
          </notes-panel>
        </v-col>
      </v-row>
    </template>
  </list-obligations>
</template>

<script>
"use strict";

import contractorCompanyService from "@/services/ContractorCompanyService";

import roles from "@/utils/roles";
import notesPanel from "../notes-panel.vue";
import listObligations from "../obligations/obligations.view.vue";

export default {
  async mounted() {
    this.contractor = await contractorCompanyService.getById(
      this.$route.params.id
    );
    this.employee = this.contractor.employees.find(
      e => e._id == this.$route.params.eid
    );
    this.obligations = await contractorCompanyService.getObligations(
      this.$route.params.id,
      this.$store.state.constants.OBLIGATIONS.TYPES.EMPLOYEES_OBLIGATION,
      { id: this.employee._id }
    );
  },
  components: {
    listObligations,
    notesPanel
  },
  computed: {
    // Las notas y los comentarios son del personal del sistema.
    isSystemUser() {
      return roles.loggedUserHasRoles(
        this.$store.state.auth.user.roles,
        this.$store.state.constants.roles.ALL_SYS_ROLES
      );
    },
    heading() {
      return "Obligaciones del empleado";
    },
    // Identificacion (DNI, CUIL o CUIT) y tipo, los que esten cargados.
    details() {
      const employee = this.employee;
      const identifier = employee.identifier || {};
      const details = [];
      if (identifier.number) {
        const label = identifier.type ? String(identifier.type).toUpperCase() : "Documento";
        details.push({ label: label, value: identifier.number });
      }
      if (employee.type && employee.type.name) {
        details.push({ label: "Tipo", value: employee.type.name });
      }
      return details;
    }
  },
  data() {
    return {
      obligations: [],
      contractor: {},
      employee: {}
    };
  },
  methods: {
    saveText(field, value) {
      return contractorCompanyService.editReferenceText(
        this.$route.params.id,
        "employees",
        this.employee._id,
        field,
        value
      );
    },
    // Se guarda tambien en el objeto local para que el valor sobreviva a un
    // nuevo render del panel.
    onTextSaved(field, value) {
      this.$set(this.employee, field, value);
    },
    async onSave(action) {
      action.item.referenceId = this.employee._id;
      const contractor = action.isNew
        ? await contractorCompanyService.addObligation(
            this.$route.params.id,
            action.item
          )
        : await contractorCompanyService.editObligation(
            this.$route.params.id,
            action.item
          );
      if (contractor) {
        this.obligations = await contractorCompanyService.getObligations(
          this.$route.params.id,
          this.$store.state.constants.OBLIGATIONS.TYPES.EMPLOYEES_OBLIGATION,
          { id: this.employee._id }
        );
      }
    },
    async onDeleteAdhoc(item) {
      let contractor = await contractorCompanyService.deleteObligation(
        this.$route.params.id,
        item
      );
      if (contractor) {
        this.obligations = await contractorCompanyService.getObligations(
          this.$route.params.id,
          this.$store.state.constants.OBLIGATIONS.TYPES.EMPLOYEES_OBLIGATION,
          { id: this.employee._id }
        );
      }
    }
  },
  mixins: []
};
</script>
